import { render, staticRenderFns } from "./editEffectDialog.vue?vue&type=template&id=0e1b07c6&scoped=true&"
import script from "./editEffectDialog.vue?vue&type=script&lang=js&"
export * from "./editEffectDialog.vue?vue&type=script&lang=js&"
import style0 from "./editEffectDialog.vue?vue&type=style&index=0&id=0e1b07c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1b07c6",
  null
  
)

export default component.exports